
import { BaseAPI } from "../../BaseAPI";

import * as environment from '../../../config/environment';
class EvBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EvBasvuruSave";
    super(baseUrl);
  }


  saveEvBasvuruSave(request: EvBasvuruRequest){
    
    return this.post("", request, true);
   
  }

}
export default new EvBasvuruAPI();
class EvBasvuruRequest {
    basvuruTuruId: number;
    sicilKodu: number;
    beyanYili: number;
    beyanAyi: number;
    butceGelirId: number;
    mukBaslamaTarihi: string;
    mukBitisTarihi?: string;
    isletmeTuruKodu?: number;
    mahalleKodu?: number;
    caddeSokakKodu?: number;
    kapiNo?: number;
    altKapiNo?: string;
    daireNo?: number;
    altDaireNo?: string;
    faaliyetKodu?: number;
    adetM2?: number;
    ekAdetM2?: number;
    gunSayisi?: number;
    biletBaslangicNo?: number;
    biletBitisNo?: number;
    iadeEdilenAdet?: number;
    biletFiyati?: number;
    matrah?: number;
    aciklama?: string;
    captchaToken?: string;

    constructor(
        basvuruTuruId: number,
        sicilKodu: number,
        beyanYili: number,
        beyanAyi: number,
        butceGelirId: number,
        mukBaslamaTarihi: string,
        mukBitisTarihi?: string,
        isletmeTuruKodu?: number,
        mahalleKodu?: number,
        caddeSokakKodu?: number,
        kapiNo?: number,
        altKapiNo?: string,
        daireNo?: number,
        altDaireNo?: string,
        faaliyetKodu?: number,
        adetM2?: number,
        ekAdetM2?: number,
        gunSayisi?: number,
        biletBaslangicNo?: number,
        biletBitisNo?: number,
        iadeEdilenAdet?: number,
        biletFiyati?: number,
        matrah?: number,
        aciklama?: string,
        captchaToken?: string
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.sicilKodu = sicilKodu;
        this.beyanYili = beyanYili;
        this.beyanAyi = beyanAyi;
        this.butceGelirId = butceGelirId;
        this.mukBaslamaTarihi = mukBaslamaTarihi;
        this.mukBitisTarihi = mukBitisTarihi;
        this.isletmeTuruKodu = isletmeTuruKodu;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.kapiNo = kapiNo;
        this.altKapiNo = altKapiNo;
        this.daireNo = daireNo;
        this.altDaireNo = altDaireNo;
        this.faaliyetKodu = faaliyetKodu;
        this.adetM2 = adetM2;
        this.ekAdetM2 = ekAdetM2;
        this.gunSayisi = gunSayisi;
        this.biletBaslangicNo = biletBaslangicNo;
        this.biletBitisNo = biletBitisNo;
        this.iadeEdilenAdet = iadeEdilenAdet;
        this.biletFiyati = biletFiyati;
        this.matrah = matrah;
        this.aciklama = aciklama;
        this.captchaToken = captchaToken;
    }
}
export { EvBasvuruRequest };
